import { apiCaller } from '@/api/apiCaller';
import { apihost } from '@/api/urls';
import { IBond} from '@/models/Bond';

const getBondsByUser = (idUser: number) => apiCaller.get(`/bond/${idUser}`, apihost);
const getStoreByDnOrName = (inputSearch: string) => apiCaller.get(`/bond/stores/${inputSearch}`, apihost);
const getGroupByName = (inputSearch: string) => apiCaller.get(`/bond/group/${inputSearch}`, apihost);
const getLocaleTypes = (idClient: number) => apiCaller.get(`/bond/localetype/${idClient}`, apihost);
const getLocaleByTypeAndName = (idLocaleType: number, inputSearch: string) => apiCaller.get(`/bond/locale/${idLocaleType}/${inputSearch}`, apihost);
const saveBond = (idUser: number, bonds: IBond[]) => apiCaller.post(`/bond/save/${idUser}`, apihost, bonds);
const updateBond = (bond: IBond) => apiCaller.put('/bond/update', apihost, bond);
const getBpaStoreByDnOrName = (inputSearch: string) => apiCaller.get(`/bond/bpastore/${inputSearch}`, apihost);
const setBpaUserStore = (idUser: number, idStore: number) => apiCaller.get(`/bond/bpastore/save/${idUser}/${idStore}`, apihost);

export const bondApi = {
    getBondsByUser,
    getStoreByDnOrName,
    getGroupByName,
    getLocaleTypes,
    getLocaleByTypeAndName,
    saveBond,
    updateBond,
    getBpaStoreByDnOrName,
    setBpaUserStore,
};
